import React, { useEffect, useState } from "react"
import { useAuth } from "../../../../Auth/AuthProvider"
import SetRequest from "../../../../_Firestore/setRequest"
import { Button } from "@/Components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/Components/ui/dialog"

const fieldClass =
  "w-full border border-mauve-200 bg-white px-3 py-2 text-mauve-900 outline-none transition focus:border-mauve-500"

const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

function isValidTitle(title) {
  return title.length >= 1 && title.length <= 200
}

function isValidRecipient(email) {
  return email.length >= 1 && email.length <= 320 && EMAIL_PATTERN.test(email)
}

export default function EditRequestDialog({
  open,
  onOpenChange,
  requestId,
  title: initialTitle,
  recipient: initialRecipient,
}) {
  const { uid } = useAuth()
  const [title, setTitle] = useState(initialTitle ?? "")
  const [recipient, setRecipient] = useState(initialRecipient ?? "")
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!open) return
    setTitle(initialTitle ?? "")
    setRecipient(initialRecipient ?? "")
    setSaving(false)
  }, [open, initialTitle, initialRecipient])

  const canSave =
    isValidTitle(title.trim()) &&
    isValidRecipient(recipient.trim()) &&
    (title.trim() !== (initialTitle ?? "") ||
      recipient.trim() !== (initialRecipient ?? ""))

  const handleSave = async (event) => {
    event.preventDefault()
    if (!canSave || saving) return

    setSaving(true)
    try {
      await SetRequest.details(
        requestId,
        { title: title.trim(), recipient: recipient.trim() },
        uid
      )
      onOpenChange(false)
    } catch (error) {
      console.error("Failed to update request details", error)
      setSaving(false)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" showCloseButton={!saving}>
        <DialogHeader>
          <DialogTitle>Edit request</DialogTitle>
          <DialogDescription>
            Update the title or recipient email. The share link stays the same.
          </DialogDescription>
        </DialogHeader>

        <form className="grid gap-3" onSubmit={handleSave}>
          <div>
            <label htmlFor="edit-request-title" className="text-sm text-mauve-500">
              Request title
            </label>
            <input
              id="edit-request-title"
              type="text"
              name="title"
              value={title}
              maxLength={200}
              disabled={saving}
              onChange={(e) => setTitle(e.target.value)}
              className={fieldClass}
              autoFocus
            />
          </div>
          <div>
            <label htmlFor="edit-request-recipient" className="text-sm text-mauve-500">
              To
            </label>
            <input
              id="edit-request-recipient"
              type="email"
              name="recipient"
              value={recipient}
              maxLength={320}
              disabled={saving}
              onChange={(e) => setRecipient(e.target.value)}
              className={fieldClass}
            />
          </div>

          <DialogFooter className="mt-2">
            <Button
              type="button"
              variant="outline"
              disabled={saving}
              onClick={() => onOpenChange(false)}
            >
              Cancel
            </Button>
            <Button type="submit" disabled={!canSave || saving}>
              {saving ? "Saving…" : "Save"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
